import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const FluentSwitcherContext = React.createContext(null);

export const withFluentSwitcher = (ComponentV8, ComponentV9) => {
  const HoC = React.forwardRef((props, ref) => (
    <FluentSwitcherContext.Consumer>
      {
        (useFluentV9) => {
          if (useFluentV9) {
            return <ComponentV9 {...props} />;
          }
          return <ComponentV8 {...props} />;
        }
      }
    </FluentSwitcherContext.Consumer>
  ));

  HoC.displayName = `withFluentSwitcher(${getDisplayName(ComponentV8)})`;

  hoistNonReactStatics(HoC, ComponentV8);

  return HoC;
};

export const withFluentV9 = (WrappedComponent, enableV9 = true) => {
  const HoC = props => (
    <FluentSwitcherContext.Provider value={enableV9} >
      <WrappedComponent {...props} />
    </FluentSwitcherContext.Provider>
  );

  HoC.displayName = `withFluentV9(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
